import { Contract, FormInput } from 'components/molecules';
import { useFormikContractHelpers } from 'hooks';
import { useTranslation } from 'react-i18next';
import { SETTLEMENT_TYPE } from 'services/templates/types';
import { IContractInputWrapperProps } from '../../wrapper/ContractInputWrapper';
import ContractInputAgreementShareValue from '../ContractInputAgreementShareValue';

interface IContractInputAgreementDefaultShareProps
  extends Omit<IContractInputWrapperProps, 'name'> {
  id: string;
  settlementType: SETTLEMENT_TYPE;
}

const ContractInputAgreementDefaultShare = ({
  id,
  settlementType,
  ...props
}: IContractInputAgreementDefaultShareProps) => {
  const { itemNameById } = useFormikContractHelpers();
  const { t } = useTranslation();

  return (
    <Contract.Input.Wrapper {...props} id={id} settlementType={settlementType}>
      <FormInput.Select
        name={`${itemNameById(id)}.content.distributionTemplateShares.id`}
        placeholder={t('input.label.default-option')}
        className='contract-input-agreement contract-input-agreement-shares'
        value={{
          label: t('contract-template.digitalDistribution.default-share'),
          value: 0,
        }}
        displayMode
      />
      <ContractInputAgreementShareValue
        id={id}
        settlementType={settlementType}
      />
    </Contract.Input.Wrapper>
  );
};

export default ContractInputAgreementDefaultShare;
